import scheduler from '@/launcher/services/scheduler';
import * as workerTimers from 'worker-timers';

let _sInterval;
let _mInterval;

export const initTimer = async ({ commit, dispatch, getters }) => {
  const time = await dispatch('getCurrentTime');
  scheduler.init(time);
  let beforeNow = performance.now();
  let afterNow;
  _sInterval = workerTimers.setInterval(() => {
    afterNow = performance.now();
    scheduler.tick(afterNow - beforeNow);
    beforeNow = performance.now();
  }, 1000);
  _mInterval = workerTimers.setInterval(async () => {
    const currentTime = await dispatch('getCurrentTime');
    scheduler.timeCorrection(currentTime);
  }, 60000);
  scheduler.on('tick', () => {
    commit('addSecondsToCurrentTime');
  });
};
export const teardownTimer = async ({ commit, dispatch, getters }) => {
  if (_sInterval !== undefined) workerTimers.clearInterval(_sInterval);
  if (_mInterval !== undefined) workerTimers.clearInterval(_mInterval);
};
